import { flexRender, Header } from "@tanstack/react-table";
import { getFrozenColumnStyle, pinnedWidthOffset } from "./getTableStyles";
import { TableStyles_Types } from "../../../Definitions";

export enum headerOrFooterKey {
	// eslint-disable-next-line no-unused-vars
	header="header",
	// eslint-disable-next-line no-unused-vars
	footer="footer"
}


export const renderHeaderAndFooter = (headers: Header<any, unknown>[], headerOrFooterKey: headerOrFooterKey, columnWidth: number[], tableStyle: TableStyles_Types) => {
	return headers.map(({column, id, getContext}) => {
		return (
			<div key={id} style={{...getFrozenColumnStyle(column.getIsPinned(), false, false, column.getIndex(), columnWidth.length, true, tableStyle, pinnedWidthOffset(column.getIsPinned(), columnWidth, column.getIndex())), position: "sticky"}}>				
				{flexRender(column.columnDef[headerOrFooterKey], getContext())}
			</div>
		)
	})
} 
